import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=059c08d8&"
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059c08d8')) {
      api.createRecord('059c08d8', component.options)
    } else {
      api.reload('059c08d8', component.options)
    }
    module.hot.accept("./forget.vue?vue&type=template&id=059c08d8&", function () {
      api.rerender('059c08d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/password/forget.vue"
export default component.exports